import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'active-cons-on-inactive-assign-dialog',
    templateUrl: 'active-cons-on-inactive-assign-dialog.html',
})
export class ActiveConsOnInactiveAssignDialog {
@Input() showMe: boolean = false;
@Output() onCloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(){}

  closeDialog() {
    this.showMe = false;
    this.onCloseDlg.emit(true);
  }
}